<template>
    <div id="pwa-intervention-demand" class="mx-2">
        <button-go-back text="Détails intervention"></button-go-back>

	    <div class="md-layout md-gutter">
		    <div class="md-layout-item md-size-100">
			    <div class="intervention-details__card">
				    <p class="font-medium mb-2 text-sm">Informations</p>
				    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
				    <div class="leading-none mb-1 text-sm">
					    <span class="font-medium">Client :</span>
					    <span class="ml-1">{{ intervention.client.name }}</span>
				    </div>
				    <div class="leading-none mb-1 text-sm">
					    <span class="font-medium">Site :</span>
					    <span class="ml-1">{{ intervention.site.name }}</span>
				    </div>
			    </div>
		    </div>
	    </div>

	    <div class="md-layout md-gutter mt-2">
		    <div class="md-layout-item md-size-100">
			    <div class="intervention-details__card">
				    <p class="font-medium mb-2 text-sm">Demande</p>
				    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
				    <div class="px-2 pt-1">
					    <div class="md-multiselect md-multiselect-multiple">
						    <label>Types de demande *</label>
						    <multiselect v-model="demand.types"
						                 :options="demandTypes"
						                 :multiple="true"
						                 :searchable="false"
						                 :close-on-select="false"
						                 :allow-empty="false"
						                 :show-labels="false"
						                 label="name"
						                 track-by="id">
							    <template slot="noOptions">La liste est vide</template>
							    <template slot="noResult">Aucun élement correspondant</template>
						    </multiselect>
					    </div>
					    <md-field class="md-invalid mt-3">
						    <label>Message *</label>
						    <md-textarea v-model="demand.message" md-autogrow></md-textarea>
						    <validation-error :errors="apiValidationErrors.message" />
					    </md-field>
				    </div>
				    <md-divider class="mb-1 mt-3 -mx-2"></md-divider>
				    <p class="font-medium mb-2 text-sm">Action</p>
				    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
				    <div class="px-2 pt-1">
					    <div class="mb-6">
						    <div class="md-multiselect">
							    <label>Utilisateur</label>
							    <multiselect v-model="demand.task.user"
							                 :options="users"
							                 :searchable="false"
							                 :allow-empty="false"
							                 :show-labels="false"
							                 label="first_name"
							                 track-by="id"
							                 placeholder="Utilisateur">
								    <template slot="noOptions">La liste est vide</template>
								    <template slot="noResult">Aucun élement correspondant</template>
							    </multiselect>
						    </div>
					    </div>
					    <div class="mb-6">
						    <div class="md-multiselect">
							    <label>Type de demande</label>
							    <multiselect v-model="demand.task.type"
							                 :options="demandTypes"
							                 :searchable="false"
							                 :allow-empty="false"
							                 :show-labels="false"
							                 :disabled="!demand.task.user"
							                 label="name"
							                 track-by="id"
							                 placeholder="Type de demande">
								    <template slot="noOptions">La liste est vide</template>
								    <template slot="noResult">Aucun élement correspondant</template>
							    </multiselect>
							    <validation-error :errors="apiValidationErrors['task.type_id']" />
						    </div>
					    </div>
					    <md-field class="md-invalid mt-3">
						    <label>Texte</label>
						    <md-textarea v-model="demand.task.text" :disabled="!demand.task.user" md-autogrow></md-textarea>
						    <validation-error :errors="apiValidationErrors['task.text']" />
					    </md-field>
				    </div>
				    <md-divider class="mb-2 mt-3 -mx-2"></md-divider>
				    <div class="flex items-center justify-end mb-1">
					    <md-button class="md-success md-icon-button md-raised my-0" @click="checkValidation" :disabled="loading">
						    <font-awesome-icon class="md-icon" :icon="['fa', loading ? 'sync-alt' : 'check-circle']" :class="{'animate-spin': loading}" />
						    <span class="font-medium leading-none ml-2">Ajouter la demande</span>
					    </md-button>
				    </div>
			    </div>
		    </div>
	    </div>
    </div>
</template>

<script>
import ButtonGoBack from "../components/ButtonGoBack";

import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

import { mapState } from "vuex";

export default {
    name: "PwaInterventionDemand",
    components: { ButtonGoBack, ValidationError },
    mixins: [formMixin, indexedDBMixin],
    data() {
        return {
            demandTypes: [],
            users: [],
            intervention: {
                client: {},
                site: {}
            },
            demand: {
                types: [],
                message: '',
                task: {
                    user: null,
                    type: null,
                    text: ''
                }
            },
	        loading: false
        }
    },
    computed: mapState({
        user: state => state.pwaAuth.technician
    }),
    methods: {
        async getInterventionDetails() {
	        const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}`)
	        const site = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/site`)
	        this.intervention = {
				...intervention.value,
		        client: site.value.client,
		        site: site.value
	        }
        },
        async getDemandTypes() {
	        const demandTypes = await this.fetchDataFromIndexedDB(`pwa/demand_types`)
            this.demandTypes = demandTypes.value
            this.demand.types.push(this.demandTypes[0])
        },
        async getUsers() {
	        const users = await this.fetchDataFromIndexedDB(`pwa/users`)
            this.users = users.value
        },
	    checkValidation() {
		    let errors = []
		    this.resetApiValidation()

		    if(!this.demand.message || this.demand.message === '') {
			    errors.push({
				    source: { pointer: '/data/attributes/message' },
				    detail: 'Le message est obligatoire'
			    })
		    }

			if(this.demand.task.user) {
				if(!this.demand.task.type) {
					errors.push({
						source: { pointer: '/data/attributes/task.type_id' },
						detail: 'Le type d\'action est obligatoire'
					})
				}
				if(!this.demand.task.text || this.demand.task.text === '') {
					errors.push({
						source: { pointer: '/data/attributes/task.text' },
						detail: 'Le texte de l\'action est obligatoire'
					})
				}
			}

		    if(errors.length > 0) {
			    this.setApiValidation(errors)
			    this.$store.dispatch('alerts/error', 'Le formulaire n\'a pas pu être validé. Merci de le corriger avant de le renvoyer')
		    } else {
			    this.submitDemand()
		    }
	    },
        async submitDemand() {
			this.loading = true
            this.resetApiValidation()

	        const payload = {
		        access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
		        types: this.demand.types.map(type => type.id).sort(),
		        message: this.demand.message,
		        task: this.demand.task.user ? {
			        type_id: this.demand.task.type.id,
			        user_id: this.demand.task.user.id,
			        text: this.demand.task.text
		        } : null,
		        intervention_id: this.intervention.id,
		        client_id: this.intervention.client.id,
		        site_id: this.intervention.site.id,
		        user_id: this.user.id
	        }

            try {
				// Generate a unique random string to make the demand request key unique in IndexedDB
	            await this.storeRequest(`pwa/demands/${payload.intervention_id}/${Date.now()}`, payload)
                await this.$store.dispatch('alerts/success', 'Demande envoyée')
                this.$router.back()
            } catch (e) {
				this.loading = false
                this.setApiValidation(e.response.data.errors)
            }
        }
    },
    mounted() {
        this.getInterventionDetails()
        this.getDemandTypes()
        this.getUsers()
    }
}
</script>

<style scoped>

</style>
